export default {
      id: "button_spinner-usage",
      viewBox: "0 0 100 100",
      url: __webpack_public_path__ + "img/icons.a12b6041.svg#button_spinner",
      toString: function () {
        return this.url;
      }
    }